import { useTranslation } from 'react-i18next';
import tw from 'twin.macro';
import BordersAndSettingIcon from '../../../components/home/borders-and-setting-icon';
import CameraDisabledInfo from '../../../components/home/camera-disabled-info';

const ExerciseTopBar = ({
  isOfflineMode,
  // MOTION_CAPTURE with no live media source behind it: the exercise was
  // prescribed for tracking and nothing is scoring it, which the user has to be
  // told rather than left to infer from a missing camera cell. Not passed while
  // FEATURES.CONNECTION_STATUS is on — its camera notice covers this instead.
  isCameraRequired = false,
  dispatch,
  timer,
  sendJsonMessage,
  isUpComingStage,
  onCameraInfoOpen,
  onCameraInfoClose,
  // Landscape phone (Figma 2058-14852): the bar sits in the reference card's top
  // corner as a single dark square, so it hugs that corner while a set is running.
  compact = false,
  // Patient-facing connection status (connection-status-stack.jsx), only with
  // FEATURES.CONNECTION_STATUS. Omitted on portrait phones, where the stack sits
  // in-flow instead.
  statusStack = null,
  // The "What's happening?" button and its panel (connection-details-panel.jsx).
  detailsButton = null,
  detailsPanel = null,
}) => {
  const { t } = useTranslation('exercise');
  return (
    // dir="ltr": flex-direction: row's main axis is writing-mode relative, so
    // without this, Arabic reverses the camera-warning/menu child order
    // (menu ends up left of the camera icon) even though the cluster's own
    // top-4 right-4 anchor is a physical position and stays put either way.
    // Like the readout overlay on the opposite corner, this is a video
    // control cluster, not reading-direction content.
    <div
      dir="ltr"
      tw="absolute top-4 right-4 z-[500] flex flex-col items-end gap-2.5"
      css={compact && tw`top-2 right-2 gap-2`}
    >
      <div tw="flex items-center gap-4" css={compact && tw`gap-2`}>
        {statusStack}
        {isCameraRequired && !isUpComingStage && (
          <div tw="max-w-[280px] rounded-[16px] border border-[#FCD34D] bg-[rgba(180,83,9,0.9)] px-4 py-3 text-[13px] font-[600] leading-[1.4] text-[#FFF7ED] shadow-[0_12px_30px_rgba(0,0,0,0.24)]">
            {t('topBar.cameraRequiredForScoring')}
          </div>
        )}
        {isOfflineMode && !isUpComingStage && (
          <div tw="rounded-[16px] bg-black/70 p-4 text-white shadow-[0_12px_30px_rgba(0,0,0,0.24)]">
            <CameraDisabledInfo onOpen={onCameraInfoOpen} onClose={onCameraInfoClose} />
          </div>
        )}
        {!isUpComingStage && (
          <div
            tw="flex items-center gap-2 rounded-[16px] bg-black/70 p-2 text-white shadow-[0_12px_30px_rgba(0,0,0,0.24)]"
            css={compact && tw`gap-1 rounded-[10px] px-3 py-2`}
          >
            {detailsButton}
            <BordersAndSettingIcon
              dispatch={dispatch}
              timer={timer}
              sendJsonMessage={sendJsonMessage}
            />
          </div>
        )}
      </div>
      {!isUpComingStage && detailsPanel}
    </div>
  );
};

export default ExerciseTopBar;
